import type { ReactNode } from "react";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { ThemeToggle } from "@/components/ThemeToggle";
import { BrandLogo } from "@/components/brand/BrandLogo";
import { cn } from "@/lib/utils";

/**
 * Kirish sahifalari (redesign v2): neytral fon, o'rtada 20px karta, tepada to'q ko'k panelda FATH TIME logosi (kvadrat versiya, dizayndagidek).
 * Til va rejim tanlovi kartaning tepasida (kirishdan oldin profil yo'q); tanlangan til kirgach profilga yoziladi.
 */
export function AuthLayout({ title, subtitle, children, footer, wide }: { title: string; subtitle?: string; children: ReactNode; footer?: ReactNode; wide?: boolean }) {
  return (
    <div className="flex min-h-screen items-start justify-center bg-canvas px-4 pt-[10vh] pb-10">
      <div className={cn("page-enter w-full rounded-card border border-border/60 bg-surface px-8 pt-6 pb-7 shadow-card", wide ? "max-w-[540px]" : "max-w-[400px]")}>
        <div className="mb-4 flex items-center justify-between gap-2">
          <LanguageSwitcher persist={false} />
          <ThemeToggle />
        </div>
        <div className="mb-6 text-center">
          <div className="rounded-2xl bg-brand px-6 py-6">
            <BrandLogo onDark className="mx-auto w-full max-w-[196px]" />
          </div>
          <div className="mt-5 text-[20px] font-semibold tracking-[-0.015em]">{title}</div>
          {subtitle && <div className="mt-1 text-[13px] text-muted">{subtitle}</div>}
        </div>
        {children}
        {footer && <div className="mt-6 text-center text-[12px] text-muted">{footer}</div>}
      </div>
    </div>
  );
}
